import { render } from "./TextsView.vue?vue&type=template&id=e60b3748&ts=true"
import script from "./TextsView.vue?vue&type=script&lang=ts"
export * from "./TextsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__